export default __webpack_public_path__ + "static/media/review-place.4636b514.svg";